//* Libraries imports
import { X } from "lucide-react";

//* Utils imports
import { CONTRACT_PDF_BASE64 } from "./utils";

type SalesContractViewerProps = {
  visible: boolean;
  onClose: () => void;
  title?: string;
};

export function SalesContractViewer({
  visible,
  onClose,
  title = "Contrato de venda",
}: SalesContractViewerProps) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white w-full max-w-4xl h-[90vh] rounded-xl flex flex-col shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>
        <div className="flex-1 bg-gray-100 p-4 overflow-hidden">
          <iframe
            src={`data:application/pdf;base64,${CONTRACT_PDF_BASE64}`}
            className="w-full h-full rounded-lg border border-gray-200 bg-white"
            title={title}
          />
        </div>
      </div>
    </div>
  );
}
